import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { handleUpdatedRecords } from "../../../utils/RecordUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { newToastEvent } from "../../../utils/ToastUtil";
import TenantAPI from "../../api/TenantAPI";

interface MutationProps {
  fileID: string;
  payload: any;
  onSuccess?: () => void;
  onError?: () => void;
}

// For updating a File Record's Name, Caption, or Transcript.
export default function useUpdateFile() {
  const tenantID = useAtomValue(tenantIDAtom);
  const queryClient = useQueryClient();

  const updateFile = useMutation({
    mutationFn: ({ fileID, payload }: MutationProps) => {
      return TenantAPI.updateFile(fileID, payload);
    },
    onSuccess: (_, { onSuccess }) => {
      const file = _.data.data.file;

      handleUpdatedRecords(queryClient, "Files", file, tenantID || "");

      newToastEvent("success", "File successfully updated.");
      callFunctionIfExists(onSuccess);
    },
    onError: (err, { onError }) => {
      const errorMessage = getErrorMessage(err) ?? "Unable to update file.";
      newToastEvent("warning", errorMessage);
      callFunctionIfExists(onError);
    },
  });

  return {
    updateFile: updateFile.mutate,
    updatingFile: updateFile.isPending,
    updateFileError: updateFile.error
      ? getErrorMessage(updateFile.error)
      : null,
  };
}
